import Artwork from 'projects/components/Artwork';
import StepHeader from 'projects/components/StepHeader';
import { Designer } from 'projects/components/User';
import { StepState } from 'projects/util/step';
import React from 'react';

interface Props {
    step: StepState;
    children: React.ReactNode;
    designers: Array<Designer>;
}

const Page: React.SFC<Props> = ({ step, children, designers }) => {
    return (
        <>
            <Artwork step={step} />
            <StepHeader step={step} designers={designers} />
            {children}
        </>
    );
};

export default Page;
